import { ModalV2 } from '@components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import TagForm from './TagForm'
import { ITag } from '@root/query/tags'

interface Props {
  tag?: ITag
  isVisible: boolean
  handleOnClose: () => void
  onCreated?: (tagId: number) => void
}

export const TagFormModal: React.FC<Props> = ({ tag, isVisible, handleOnClose, onCreated }) => {
  const [t] = useTranslation()

  return (
    <ModalV2
      isVisible={isVisible}
      handleOnClose={handleOnClose}
      header={tag ? t('settings.tags.form.editTitle') : t('settings.tags.form.newTitle')}
      width={500}
      height={600}
    >
      <TagForm handleFormClose={handleOnClose} tag={tag} onCreated={onCreated} />
    </ModalV2>
  )
}
